import { useContext } from 'react'
import { FeatureContext } from '../'

/**
 * Returns a feature toggle value for the specified toggle key.
 * The feature toggles are provided by FeatureProvider.
 * If no toggle key is specified then it returns the whole feature toggle object.
 *
 * @param {string} [featureKey] - "[toggle store name].[toggle key]" or "[toggle key]"
 * @param {*} [defaultValue] - The value to return if the target toggle does not exist
 * @returns {*}
 */
const useFeature = (featureKey, defaultValue) => {
  const features = useContext(FeatureContext)

  if (!features || (featureKey == null && defaultValue)) {
    return defaultValue
  }

  if (typeof featureKey === 'string') {
    let storeName = null

    if (/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_.]+$/.test(featureKey)) {
      ;[, storeName, featureKey] = featureKey.match(/^([A-Za-z0-9-_]+)\.([A-Za-z0-9-_.]+)$/)
    }

    const result = storeName ? features?.[storeName]?.[featureKey] : features?.[featureKey]

    return result ?? defaultValue
  }

  return features
}

export default useFeature
